// Pings the media service worker while anything is playing, so the browser does not stop the worker
// (and drop its in-memory keys) in the middle of a video. Media events don't bubble, so "playing" is
// heard with capture on the document, while the events that end playback are heard on the element
// itself: an element that is unmounted fires its pause after it left the document.
export function startKeepalive({ ping, doc = document, intervalMs = 20000 }) {
  const playing = new Set();
  const stopEvents = ["pause", "ended", "emptied", "error"];
  let timer = null;
  const sync = () => {
    if (playing.size && !timer) timer = setInterval(tick, intervalMs);
    if (!playing.size && timer) {
      clearInterval(timer);
      timer = null;
    }
  };
  const forget = (element) => {
    playing.delete(element);
    for (const type of stopEvents) element.removeEventListener(type, onStopped);
  };
  // Also lets go of elements whose stop event was missed, so none is retained or pinged for.
  function tick() {
    for (const element of [...playing]) if (!element.isConnected || element.paused) forget(element);
    sync();
    if (playing.size) ping();
  }
  function onStopped(event) {
    forget(event.currentTarget ?? event.target);
    sync();
  }
  const onPlaying = (event) => {
    const element = event.target;
    if (!(element instanceof HTMLMediaElement)) return;
    if (!playing.has(element)) {
      playing.add(element);
      for (const type of stopEvents) element.addEventListener(type, onStopped);
    }
    sync();
  };
  doc.addEventListener("playing", onPlaying, true);
  return () => {
    doc.removeEventListener("playing", onPlaying, true);
    for (const element of [...playing]) forget(element);
    sync();
  };
}
